// Configuration for the booking system
// In production, use environment variables

export const CONFIG = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8787/api',
  TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
}

export const ROOMS = ['Gedung Gereja', 'Ruang Konsistori/Persikapen', 'Ruang Sermon Bogor Barat']

export const BOOKING_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled'
}
